import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, toRefs, ref } from "vue";
import store from "@/store";
import useFavorite from "../composables/useFavorite";
export default {
  components: {},
  name: "SelectFavorite",
  props: {
    choseAsset: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['ok'],
  setup(props, ctx) {
    const elTreee = ref({});
    const data = reactive({
      show: false,
      favData: []
    });
    const {
      doFavorite
    } = useFavorite();
    const defaultProps = {
      label: 'name',
      children: 'children'
    };
    const close = () => {
      data.show = false;
    };
    const visible = () => {
      data.favData = store.state.favData;
      data.show = true;
    };

    // 确认收藏
    const confirmHandler = () => {
      let currentNode = elTreee.value.getCurrentNode();
      if (!currentNode) {
        ElMessage.warning("请选择收藏夹");
        return;
      }
      let json = {
        dataId: props.choseAsset.id,
        parentId: currentNode.id,
        name: props.choseAsset.assetsName,
        nodeTyp: "1"
      };
      console.log(json, "json");
      doFavorite(json).then(() => {
        data.show = false;
        ctx.emit('ok', true);
      });
    };
    return {
      ...toRefs(data),
      defaultProps,
      elTreee,
      close,
      visible,
      confirmHandler
    };
  }
};